import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalEventsManager } from './global-events-manager';
import { baseAPIWithoutNodey } from './endpoint';

@Injectable({
providedIn: 'root'
})

export class ScheduleAgentsAIService {
  private headers = { 'content-type': 'application/json'};

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  sendAgencyEmailContent(data: { agencyName: string, shifts: { shiftDate: string; shiftString: string }[] }): Observable<any>  {
    const body = data;
    const url = `${baseAPIWithoutNodey}/scheduleAgents/agencySummary`;
    return this.http.post(url, body, {'headers': this.headers })
    .pipe(
      catchError(this.handleError('sendAgencyEmailContent'))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
